
import React, { useContext, useEffect, useState } from 'react'
import FileService from '../services/file';
import StorageService from '../services/storage';
import { Context } from "../AppContext";
import { ContextUI } from '../uiContext'; 
const RasciProcessSearch = (props) => {
    const contextUI = useContext(ContextUI);
    const context = useContext(Context);
 //   const [rasci, setRasci] = useState();
  //  const [selectedRole,setSelectedRole] = useState();

    useEffect(() => {
        contextUI.setTitle('Werkprocessen / producten');
        contextUI.setSubTitle('');
     //   contextUI.setShowBackButton(false);

       
            let foundFile = context.info.Index.find(file => {return file.Name == 'rasci.json'});

            if (foundFile) {
                FileService.getContent(foundFile.DPath, StorageService.getStorageFileName(foundFile), true)
                    .then(content => {
                        let obj = (typeof content === 'string') ? JSON.parse(content) : content;
                        let foundProcess = obj.processes.find(pro => {return pro.level==2 && pro.id == props.match.params.number});
                 
                        if(foundProcess){
                            props.history.push('/rasci/processes/' + foundFile.DPath + '/' + foundProcess._id);
                        }else{
                            props.history.push('/');
                        }
                    })
                    .catch(err => {
                        console.log(err);
                       
                    })
            }
     
    }, [])
return null;
/*
    if (!rasci) return null;
    return (
        <div  >
            <ViewRoles rasci={rasci}  selected={selectedRole}  history={props.history} fileID={props.match.params.id}/>
        </div>
    )
        */
}
export default RasciProcessSearch
